import { LocalFile } from "@/hooks/types";
import SSRIcon from "@ingka/ssr-icon";
import document from "@ingka/ssr-icon/paths/document";
import PdfPreview from "./PdfPreview";
import { FileToUploadItem } from "./FileToUploadItem";
import { validateDocumentFile } from "./utils";

type DocumentFilesToUploadProps = {
  localFiles: LocalFile[];
  uploadProgress: Record<string, number>;
  removeFile: (file: LocalFile) => void;
  retryUpload: (fileUrl: string) => void;
};

const DocumentFilesToUpload = ({
  localFiles,
  uploadProgress,
  removeFile,
  retryUpload,
}: DocumentFilesToUploadProps) => {
  return (
    <ul className="grid grid-cols-1 gap-x-space125 gap-y-space100 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {localFiles.map((localFile) => {
        const validationResult = validateDocumentFile(localFile.file);
        const progress = uploadProgress[localFile.url];
        const warningMessage = !validationResult.isValid
          ? validationResult.message
          : undefined;

        return (
          <FileToUploadItem
            key={localFile.url}
            localFile={localFile}
            progress={progress}
            onRemove={() => removeFile(localFile)}
            onRetry={() => retryUpload(localFile.url)}
            isRetrying={localFile.uploadStatus === "uploading"}
            mediaElement={
              localFile.file.type === "application/pdf" ? (
                <PdfPreview url={localFile.url} />
              ) : (
                <div className="flex size-full items-center justify-center bg-neutral-100">
                  <SSRIcon
                    paths={document}
                    className="size-12 text-neutral-500"
                  />
                </div>
              )
            }
            warningMessage={warningMessage}
          />
        );
      })}
    </ul>
  );
};

export default DocumentFilesToUpload;
